/**
 * Serialize calendar event data for API requests and responses
 */
class CalendarEventSerializer {
  fromJSON(apiData) {
    const event = apiData.data || apiData;

    if (!event) {
      return null;
    }

    const frontendEvent = {
      id: event.id,
      title: event.title || "",
      description: event.description || "",

      start: event.start_date
        ? this._formatDateForFrontend(event.start_date)
        : event.start
        ? this._formatDateForFrontend(event.start)
        : "",
      end: event.end_date
        ? this._formatDateForFrontend(event.end_date)
        : event.end
        ? this._formatDateForFrontend(event.end)
        : "",

      startDate: event.start_date || event.start,
      endDate: event.end_date || event.end,

      color: event.color || "#8b5cf6",
      event_type: event.event_type || "general",
      academic_year: event.academic_year || "2025-2026",

      created_by: event.created_by,
      updated_by: event.updated_by,
      created_at: event.created_at,
      updated_at: event.updated_at,
      is_active: event.is_active !== false,

      metadata: {
        created_at: event.created_at,
        updated_at: event.updated_at,
        version_id: event.version_id,
      },
    };

    return frontendEvent;
  }

  toJSON(frontendData) {
    const backendEvent = {
      title: frontendData.title || "",
      description: frontendData.description || "",

      start_date: frontendData.start || null,
      end_date: frontendData.end || null,

      color: frontendData.color || "#8b5cf6",
      event_type: frontendData.event_type || "general",
      academic_year: frontendData.academic_year || "2025-2026",

      created_by: frontendData.created_by,
      updated_by: frontendData.updated_by,
    };

    Object.keys(backendEvent).forEach((key) => {
      if (backendEvent[key] === null || backendEvent[key] === undefined) {
        delete backendEvent[key];
      }
    });

    return backendEvent;
  }

  /**
   * Convert date string from backend format to frontend format
   */
  _formatDateForFrontend(backendDate) {
    if (!backendDate) return "";

    try {
      const date = new Date(backendDate);
      if (isNaN(date.getTime())) {
        return "";
      }

      return date.toISOString().split("T")[0];
    } catch (error) {
      return "";
    }
  }

  /**
   * Convert date string from frontend format to backend format
   */
  _formatDateForBackend(frontendDate) {
    if (!frontendDate) return null;

    try {
      if (frontendDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return frontendDate;
      }
      if (frontendDate.includes("T")) {
        return frontendDate.split("T")[0];
      }

      const date = new Date(frontendDate);
      if (isNaN(date.getTime())) {
        return null;
      }

      return date.toISOString().split("T")[0];
    } catch (error) {
      return null;
    }
  }

  /**
   * Transform search response format
   */
  fromSearchJSON(searchResponse) {
    if (!searchResponse || !searchResponse.data) {
      return { hits: [], total: 0 };
    }

    const data = searchResponse.data;

    if (Array.isArray(data)) {
      return {
        hits: data.map((item) => this.fromJSON(item)),
        total: data.length,
      };
    }

    if (data.hits && Array.isArray(data.hits)) {
      return {
        hits: data.hits.map((item) => this.fromJSON(item)),
        total: data.total || data.hits.length,
      };
    }

    if (data.data && Array.isArray(data.data)) {
      return {
        hits: data.data.map((item) => this.fromJSON(item)),
        total: data.total || data.data.length,
      };
    }

    return { hits: [], total: 0 };
  }
}

export const serializer = new CalendarEventSerializer();
export default CalendarEventSerializer;
